<script setup lang="ts">
import BaseButton, {Props} from "@/core/components/base/BaseButton.vue";
import {clsx} from "clsx";

const {class: className, iconLeft = false, ...props} = defineProps<Props & { iconLeft?: boolean }>();

</script>

<template>
  <BaseButton
    v-bind="props" color="#F8E896" density="comfortable"
    :class="clsx([
      'px-0 py-1 text-primary flex items-center',
      iconLeft ? 'pr-4 pl-1' : 'pl-4 pr-1',
      className
    ])"
  >
    <img
      v-if="iconLeft"
      alt="coin"
      src="@/assets/images/apodis-coin.png"
      class="w-6 aspect-square mr-2"
    >
    <slot />
    <img
      v-if="!iconLeft"
      alt="coin"
      src="@/assets/images/apodis-coin.png"
      class="w-6 aspect-square ml-2"
    >
  </BaseButton>
</template>

<style scoped>

</style>
